import { render } from "./iconCloseFill.vue?vue&type=template&id=0b516ffe"
import script from "./iconCloseFill.vue?vue&type=script&lang=js"
export * from "./iconCloseFill.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__